import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import colors from "@constants/colors"
import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import { body16MainStyles } from "@constants/typography"
import AnimatedDash, {
  animationStyles,
} from "@components/buttons/common/AnimatedDash"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  cursor: pointer;
`

const GatsbyLink = styled(Link)<any>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
  ${animationStyles}
`

const ImageWrapper = styled.div`
  ${ImageHelperContainer} {
    padding: 24px;
    transition: background-color ${animation.medium} ${cubicBezier};
    background-color: ${colors.backgroundGray};

    @media ${breakpoints.laptop} {
      &:hover {
        background-color: ${colors.backgroundGrayHover};
      }
    }
  }
`

const Content = styled.div`
  display: flex;
  width: 100%;
  padding-top: 14px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: transparent;
`

const Title = styled.div`
  ${body16MainStyles}
`

const DashWrapper = styled.div`
  margin-right: 16px;
`

interface LinkBlockProps {
  image: string
  title: string
  link?: string
  className?: string
  onClick?: () => void
}

const LinkBlock = (props: LinkBlockProps) =>
  props.image ? (
    <GatsbyLink to={props.link || ""}>
      <Container className={props.className} onClick={props.onClick}>
        <ImageWrapper>
          <ImageHelper src={props.image} />
        </ImageWrapper>
        <Content>
          <Title>{props.title}</Title>
          <DashWrapper>
            <AnimatedDash />
          </DashWrapper>
        </Content>
      </Container>
    </GatsbyLink>
  ) : null

export default LinkBlock
